import module from 'fan/proyecto/module.js'
import template from './template.html'

function Modelo () {
  this.colaborador_id = null
  this.colaborador = ''
  this.deduccion_valor = null
  this.importe = null
  this.numero_credito = null
  this.completado = false
  this.error = null
}

const currencyReplaceRegex = /[^0-9.-]+/g
const decodificarNumero = (value) => parseFloat(Number(value.replace(currencyReplaceRegex, '')).toFixed(2))

export class FanProyectoColaboradoresCreditosFonacotComponent {
  constructor ($state) {
    this.$state = $state
    this.actualizando = false
    this.completado = false
    this.alertas = []
    this.data = null
    this.error = null
    this.step = 1
    this.idProyecto = null
    this.resultados = null
    this.resultadosModal = null
    this.modelo = Modelo
  }

  $onInit () {
    this.headers = [
      {
        id: 'colaborador_id',
        name: 'Colaborador ID',
        group: 'REQUERIDO',
        parser: (value) => (Number(value) || 0),
        processor: (object, value) => {
          object.colaborador_id = value

          return object
        },
        match: (value) => ['COLABORADOR_ID', 'EMPLEADO_ID', 'NOMBRE_ID'].indexOf(value.toUpperCase()) >= 0,
      }, {
        id: 'numero_credito',
        name: 'Número crédito',
        group: 'REQUERIDO',
        parser: (value) => value.trim(),
        processor: (object, value) => {
          object.numero_credito = value

          return object
        },
        match: (value) => ['NUMERO_CREDITO', 'NUMERO CREDITO'].indexOf(value.toUpperCase()) >= 0,
      }, {
        id: 'colaborador',
        name: 'Colaborador',
        group: 'REQUERIDO',
        parser: (value) => value.trim(),
        processor: (object, value) => {
          object.colaborador = value

          return object
        },
        match: (value) => ['COLABORADOR', 'EMPLEADO', 'NOMBRE'].indexOf(value.toUpperCase()) >= 0,
      }, {
        id: 'deduccion_valor',
        name: 'Deducción mensual',
        group: 'REQUERIDO',
        match: (value) => ['DEDUCCION VALOR', 'DEDUCCION_VALOR'].indexOf(value.toUpperCase()) >= 0,
        parser: (value) => {
          let importe = value === '' ? null : decodificarNumero(value)
          return Number.isFinite(importe) ? importe : null
        },
        processor: (object, value) => {
          object.deduccion_valor = value

          return object
        },
      },
      {
        id: 'deduccion_tipo',
        name: 'Deducción tipo',
        group: 'REQUERIDO',
        parser: (value) => value.trim(),
        processor: (object, value) => {
          object.deduccion_tipo = value.toUpperCase()

          return object
        },
        match: (value) => ['DEDUCCION_TIPO', 'DEDUCIION TIPO'].indexOf(value.toUpperCase()) >= 0,
      },
    ]
  }

  actualizar (data) {
    if (!data) return
    this.resultados = data
    this.resultados.map((item, indice) => item.indice = indice + 1)
    this.step = 3
  }

  iniciar () {
    this.resultadosModal = this.resultados.filter((item) => !item.actualizado)
    this.completado = true
  }

  terminar (event) {
    this.completado = false
    if (event) {
      let error = event.some((item) => item.error)
      if (!error) this.$state.go('proyecto.colaboradores.lista')
      this.resultados.map((item) => {
        event.forEach((data) => {
          if (item.indice === data.indice) {
            item.error = data.error
            item.actualizado = data.actualizado
            item.completado = data.completado
          }
        })
      })
    }
  }

  importar (event) {
    this.data = null
    this.error = null
    this.alertas = []
    if (!event || !event.headers || !event.data) return

    if (event.headers.indexOf('colaborador') < 0 && event.headers.indexOf('colaborador_id') < 0) {
      return this.error = 'Especifique la columna "Colaborador" o "Colaborador ID"'
    }

    if (event.headers.indexOf('numero_credito') < 0) {
      return this.error = 'Especifique la columna "Número de crédito"'
    }

    if (event.headers.indexOf('deduccion_valor') < 0) {
      return this.error = 'Especifique la columna "Deducción"'
    }

    if (event.headers.indexOf('deduccion_tipo') < 0) {
      return this.error = 'Especifique la columna "Tipo deducción"'
    }

    this.data = event.data.filter((item, index) => {
      if (['P', 'I', 'C'].indexOf(item.deduccion_tipo.toUpperCase()) < 0) {
        this.alertas.push(`Se omitirá la fila #${index + 1} pues no es valido el dato en la columna deducción tipo.`)
        return false
      }
      if (item.deduccion_valor <= 0) {
        this.alertas.push(`Se omitirá la fila #${index + 1} pues el monto a deducir es 0`)
        return false
      }

      if (item.deduccion_tipo === 'P'){
        console.log(item.deduccion_valor)
        if(item.deduccion_valor > 100 || item.deduccion_valor < 0){
          this.alertas.push(`Se omitirá la fila #${index + 1}, pues solo se permite 100% como máximo y 1% como mínimo`)
          return false
        } else {
          item.deduccion_valor = item.deduccion_valor / 100
        }
      }

      return true
    })
  }

  validar () {
    this.alertas = []
    if (this.step === 2) return

    this.step = 2
  }
}

module.component('fanProyectoColaboradoresCreditosInfonavit', {
  controller: FanProyectoColaboradoresCreditosFonacotComponent,
  template,
  bindings: {
    proyectoId: '<',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/colaboradores/creditos/infonavit/component.js